export const getMissingParamsFromUrl = (url, defaultParams) => {
  const paramsFromApi = new URLSearchParams(url?.split('?')?.[1]);
  const missingParams = {};

  for (const keyParam in defaultParams) {
    if (!paramsFromApi.has(keyParam)) {
      missingParams[keyParam] = defaultParams[keyParam];
    }
  }

  return { missingParams };
};
